import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import getLoyaltyActionRewardProgress from 'loyalty/lib/getLoyaltyActionRewardProgress'

type CustomerActionRewardsResponse =
  paths['/api/lux-loyalty/customer/{customerId}/action-reward-records']['get']['responses']['200']['content']['application/json']

type ContractActionReward = CustomerActionRewardsResponse['result'][number]
type ContractAppliedRecord = ContractActionReward['appliedRecords'][number]

type CalculateActionRewardsEarnResponse =
  paths['/api/lux-loyalty/points/action-rewards/calculate-earn/batch']['post']['responses']['200']['content']['application/json']

export type LoyaltyActionRewardCalculateEarnResult = CalculateActionRewardsEarnResponse['results'][number]

function mapLoyaltyActionRewardAppliedRecord(
  record: ContractAppliedRecord,
): App.LoyaltyActionRewardAppliedRecord {
  return {
    id: record.id,
    customerId: record.customerId,
    action: record.action,
    bonusPoints: record.bonusPoints,
    statusCredits: record.statusCredits,
    bonusStatusCredits: record.bonusStatusCredits,
    metaData: record.metaData,
    status: record.status,
    createdAt: record.createdAt,
    updatedAt: record.updatedAt,
  }
}

/**
 * Maps a customer action-reward catalogue row to the domain type.
 * Omits `earnEstimate` — the unified fetch merges calculate results later.
 */
function mapLoyaltyActionReward(record: ContractActionReward): App.LoyaltyActionReward {
  const appliedRecords = record.appliedRecords.map(mapLoyaltyActionRewardAppliedRecord)
  const progress = getLoyaltyActionRewardProgress({
    allowRepeat: record.allowRepeat,
    maxRepeat: record.maxRepeat,
    appliedRecords,
  })

  return {
    id: record.id,
    actionName: record.actionName,
    rewardType: record.rewardType,
    groupType: record.groupType,
    title: record.title,
    description: record.description,
    allowRepeat: record.allowRepeat,
    maxRepeat: record.maxRepeat,
    eligible: record.eligible,
    appliedRecords,
    status: record.status,
    isComplete: progress.isFullyComplete,
  }
}

export function mapLoyaltyActionRewards(records: Array<ContractActionReward>): Array<App.LoyaltyActionReward> {
  return records
    .filter(record => record.eligible || record.appliedRecords.length > 0)
    .map(mapLoyaltyActionReward)
}
